// Chakra imports
import { Flex,FormControl,FormLabel,Input,Switch,Button } from "@chakra-ui/react";
import React,{useState, useEffect} from "react";
import InvitationsTable from "./components/InvitationsTable";
import Invite from "./components/Invite";

import Projects from "./components/Projects";
import { tablesTableData, dashboardTableData } from "variables/general";
import axios from 'axios';
import { getToken } from "utils/auth";
import config from "config";

function Users() {
  const [invitations, setInvitations] = useState([]);


  useEffect(() => {
    const fetchUserProfiles = async () => {
      const token = getToken()
      try {
        const response = await axios.get(`${config.API_URL}/invitation/invitations`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }); // Assuming your backend API endpoint is /api/users
        setInvitations(response.data);
      } catch (error) {
        console.error('Error fetching user profiles:', error);
      }
    };

    fetchUserProfiles();
  }, []); // Empty dependency array to ensure the effect runs only once

  return (
    <Flex direction='column' pt={{ base: "62px", md: "75px", xl: "88px" }}>
      <Invite title={"Invite by email"} setInvitations={setInvitations}/>
      <InvitationsTable
        title={"Invitations Table"}
        captions={["EMAIL", "CREATION", "EXPIRATION", "STATUS", "DELETE", "RENEW" ]}
        data={invitations}
        setInvitations={setInvitations}
      />
    </Flex>
  );
}

export default Users;
